// Auth
export const ROUTE_ROOT = "/";
export const ROUTE_LOGIN = "/auth/login";
export const ROUTE_SIGNUP = "/auth/signup";
export const ROUTE_OTP = "/auth/otp";

//Dashboard Assignments
export const ROUTE_ASSIGNMENTS = `/assignments`;

// Classroom
export const ROUTE_CLASSROOM = "/classroom";
export const ROUTE_CLASSROOM_DETAIL = `${ROUTE_CLASSROOM}/:batch_id/:coaching_id`;
export const ROUTE_VIEW_ALL_CLASSROOM_PENDING = `${ROUTE_CLASSROOM}/view-all/pending/:coaching_id`;
export const ROUTE_VIEW_ALL_CLASSROOM_UPCOMING = `${ROUTE_CLASSROOM}/view-all/upcoming/:coaching_id`;
export const ROUTE_VIEW_ALL_CLASSROOM_RECORDINGS = `${ROUTE_CLASSROOM}/view-all/recordings/:coaching_id`;

// Educentre
export const ROUTE_EDUCENTRE = "/educentre";
export const ROUTE_EDUCENTRE_DETAIL = `${ROUTE_EDUCENTRE}/:coaching_id`;
export const ROUTE_EDUCENTRE_COURSES = `${ROUTE_EDUCENTRE}/:coaching_id/courses`;

// Notes
export const ROUTE_NOTES = "/notes";
export const ROUTE_NOTES_MATERIAL = `${ROUTE_NOTES}/material/:coaching_id`;
export const ROUTE_NOTES_RECORDINGS = `${ROUTE_NOTES}/material/:id/recordings`;
export const ROUTE_NOTES_ASSIGNMENTS = `${ROUTE_NOTES}/material/:id/assignments`;
export const ROUTE_NOTES_WRITTEN_NOTES = `${ROUTE_NOTES}/material/:id/writtennotes`;

// Profile
export const ROUTE_PROFILE = "/profile";
export const ROUTE_PROFILE_EDIT = `${ROUTE_PROFILE}/edit`;

//Notifications
export const ROUTE_NOTIFICATIONS = "/notifications";

//Payments
export const ROUTE_PAYMENTS = "/payments";
